module.exports = __webpack_public_path__ + "img/elder-avatar.dbf66753.png";